import { Stack, Switch, Tooltip } from "@mui/material";
import { Control, Controller } from "react-hook-form";

import type { SkillEditorFormValues } from "./SkillEditor";

import { SkillAccessChips } from "./SkillAccessChips";

type SkillTitleBarControlsProps = {
  control: Control<SkillEditorFormValues>;
  readOnly: boolean;
  isStaff: boolean;
  /** New skills start enabled; the switch only appears once the skill exists. */
  showEnabled: boolean;
};

export function SkillTitleBarControls({
  control,
  readOnly,
  isStaff,
  showEnabled,
}: SkillTitleBarControlsProps) {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <SkillAccessChips
        control={control}
        readOnly={readOnly}
        scopeEditable={!readOnly}
        allowGlobal={isStaff}
        allowStaffAudience={isStaff}
      />
      {showEnabled ? <SkillEnabledSwitch control={control} readOnly={readOnly} /> : null}
    </Stack>
  );
}

/** Unlabeled on/off switch; the tooltip says what each state means. */
function SkillEnabledSwitch({
  control,
  readOnly,
}: {
  control: Control<SkillEditorFormValues>;
  readOnly: boolean;
}) {
  return (
    <Controller
      name="enabled"
      control={control}
      render={({ field }) => (
        <Tooltip
          title={
            field.value
              ? "On: Scout can find and use this skill"
              : "Off: Scout won't find or use this skill"
          }
        >
          {/* A disabled Switch fires no pointer events, so the tooltip needs a wrapper. */}
          <span>
            <Switch
              size="small"
              checked={field.value}
              onChange={(event) => field.onChange(event.target.checked)}
              disabled={readOnly}
              slotProps={{ input: { "aria-label": "Skill enabled" } }}
            />
          </span>
        </Tooltip>
      )}
    />
  );
}
